import messages from "../languages/index"
import store from "../store"
let lang = localStorage.getItem('language')

export default {
  install(Vue) {
    Vue.prototype.$exportDocument = async function (endpoint, body, extension, range, route) {
      let response;
      store.commit("setProgressLinear", true);

      await Vue.prototype.$axios.post(
        endpoint,
        Vue.prototype.$formdata(body), {
          responseType: "blob"
        },
      ).then(response => {
        let documentName = "";
        if (
          range && route == "AgentUsersReport" ||
          range && route == "AgentSportsReport" ||
          range && route == "AgentDepositsReport" 
        ) {
          const data_inicio = new Date(range.data_inicio).toLocaleDateString();
          const data_final = new Date(range.data_final).toLocaleDateString();
          documentName = `${messages[lang].report} ${data_inicio} - ${data_final}`;
          // documentName = `${messages[lang].report} ${data_inicio} - ${data_final} - ${exportName}`;
        } else if (range) {
          const data_inicio = new Date(range.date_start).toLocaleDateString();
          const data_final = new Date(range.date_final).toLocaleDateString();
          documentName = `${messages[lang].report} ${data_inicio} - ${data_final}`;
        } else {
          documentName = messages[lang].report;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${documentName}.${extension}`);
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        store.commit("setNotification", {
          msg: messages[lang].noDataFound,
          color: "warning",
        });
      })
    }
  }
}